import { Link, useNavigate } from 'react-router-dom';

export default function Footer() {
  const navigate = useNavigate();

  return (
    <footer className="bg-background-900 text-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-cloud-line text-lg text-white"></i>
              </div>
              <span className="text-xl font-heading font-bold text-white">开云</span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed">
              开云是值得信赖的综合服务平台，致力于为用户提供高效、安全、便捷的数字化体验。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">快速导航</h4>
            <ul className="space-y-2.5">
              <li><Link to="/" className="text-sm text-background-400 hover:text-white transition-colors">首页</Link></li>
              <li><Link to="/categories" className="text-sm text-background-400 hover:text-white transition-colors">分类浏览</Link></li>
              <li><Link to="/articles" className="text-sm text-background-400 hover:text-white transition-colors">文章中心</Link></li>
              <li><Link to="/about" className="text-sm text-background-400 hover:text-white transition-colors">关于我们</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">热门分类</h4>
            <ul className="space-y-2.5">
              <li><Link to="/categories/platform-intro" className="text-sm text-background-400 hover:text-white transition-colors">平台入门</Link></li>
              <li><Link to="/categories/feature-guide" className="text-sm text-background-400 hover:text-white transition-colors">功能指南</Link></li>
              <li><Link to="/categories/use-cases" className="text-sm text-background-400 hover:text-white transition-colors">使用场景</Link></li>
              <li><Link to="/categories/faq" className="text-sm text-background-400 hover:text-white transition-colors">常见问题</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">联系我们</h4>
            <ul className="space-y-2.5">
              <li className="flex items-center gap-2 text-sm text-background-400">
                <i className="ri-phone-line"></i> 400-888-6666
              </li>
              <li className="flex items-center gap-2 text-sm text-background-400">
                <i className="ri-mail-line"></i> contact@kaiyun.com
              </li>
              <li className="flex items-start gap-2 text-sm text-background-400">
                <i className="ri-map-pin-line mt-0.5"></i> 北京市朝阳区建国路88号
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-700/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-background-500">
            &copy; 2026 开云 版权所有 | 保留一切权利
          </p>
          <div className="flex items-center gap-4">
            <button
              onClick={() => navigate('/articles')}
              className="text-sm text-background-500 hover:text-background-200 transition-colors whitespace-nowrap cursor-pointer"
            >
              使用条款
            </button>
            <button
              onClick={() => navigate('/articles')}
              className="text-sm text-background-500 hover:text-background-200 transition-colors whitespace-nowrap cursor-pointer"
            >
              隐私政策
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
}